import Entity from '../entity'
import Campo from './campo';
export default class CamposOzoneACallCenter extends Entity<number>{
    campoCampana: string;
    campoId: number;
    campo: Campo;
    campoVozitel: string;
    vozitelCampanaId:number
}